import React from 'react'
import CreateTestForm from './CreateTestForm'
import {createTest, updateTest} from '../../actions/index'
//import moment from 'moment-timezone'
//import {formatInt} from '../common/RenderFields'
import { SubmissionError } from 'redux-form'
import _ from 'lodash'
import {statuses} from '../../constants'

const CreateTest = (props) => {

    // const getDate = (day, hours, minutes) => {
    //     const d = new Date()
    //     const addDate = day === 'Tomorrow' ? 1 :(day === 'Yesterday' ? -1 : 0)
    //     const dateStr = `${d.getFullYear()}-${formatInt(d.getMonth() + 1)}-${formatInt(d.getDate() + addDate)}`
    //     const timeStr = `${formatInt(parseInt(hours,10))}:${formatInt(parseInt(minutes,10))}`
    //     const m = moment(`${dateStr}T${timeStr}:00.000Z`)
    //     return m.toDate()
    // }

    const unplannedInitiallyRejected = () => {
        return false// ((props.dataError || {}).createTestCode || '').toLowerCase() === errorCodes.UnplannedTestWillBreach
    }

    const handleSubmit = (values) => {
        console.log('handleSubmit', values)

        //props.dispatch(createTest(values)) //testing

        _.forEach([
            'maintenanceAgency',
            'operator',
            'aircraft',
            'aircraftRegistration',
            'reason',
            'weather',
            'location',
            "heading",
            "duration",
            'startedAt',
            'firstEngineOn',
            'lastEngineOff',
            'scheduledDeparture'], k => {
            if (!values[k]) {
                //console.log('missing 1' , k)
                throw new SubmissionError({ _error: 'Fill out all the fields' })
            }
        })

        // _.forEach(['startedAt',
        //     'firstEngineOn',
        //     'lastEngineOff',
        //     'scheduledDeparture'], k => {
        //     if (!values[`${k}Day`] || !!values[`${k}Hours`] || !!values[`${k}Minutes`]) {
        //         console.log('missing 2', k, values[`${k}Day`], !!values[`${k}Hours`], !!values[`${k}Minutes`])
        //         throw new SubmissionError({ _error: 'Fill out all the fields' })
        //     }
        //     values[k] = getDate(values[`${k}Day`], values[`${k}Hours`], values[`${k}Minutes`])
        // })

        if (!values.aircraft
            || !values.heading
            || !values.location) {
            //console.log('missing 3', values.aircraft, values.heading, values.location)
            throw new SubmissionError({ _error: 'Fill out all the fields' })
        }

        let totalEngineTime = 0;
        [1,2,3,4].forEach(i => {
            [`Idle`, `Med`, `High`].forEach(s => {
                if (typeof values[`e${i}${s}`] === 'string') {
                    values[`e${i}${s}`] = parseInt(values[`e${i}${s}`], 10) || 0
                } else {
                    values[`e${i}${s}`] = values[`e${i}${s}`] || 0
                }
                totalEngineTime += values[`e${i}${s}`]
            })
        })
        if (totalEngineTime === 0) {
            //console.log('missing 4')
            throw new SubmissionError({ _error: 'Fill out all the fields' })
        }

        if (values.aircraft === 'Other' && !values.otherAircraft) {
            throw new SubmissionError({ _error: 'Aircraft type required' })
        }

        if (values.operator === 'Other' && !values.otherOperator) {
            throw new SubmissionError({ _error: 'Operator required' })
        }

        values.lightMaintenance = values.duty === 'light'
        values.heavyMaintenance = values.duty === 'heavy'
        values.antarctic = !!values.antarctic
        values.naturalDisaster = !!values.naturalDisaster
        values.approved = !!values.approved
        values.runway11InUse = !!values.runway11InUse
        values.unplanned = !!values.unplanned

        values.maxSimultaneousHighPower = values.maxSimultaneousHighPower || 1

        //values.totalIdle = values.e1Idle + values.e2Idle
        //values.totalMed = values.e1Med + values.e2Med
        //values.totalHigh = values.e1High + values.e2High

        //values.duration = values.durationMins * 60 * 1000 //millis
        values.status = values.status || 'SCHEDULED'
        values.approvalDoc = props.uploadUrl
        values.overrideUnplannedBreach = unplannedInitiallyRejected()

        console.log('handleSubmit ok', values)

        if (props.editingTest) {
            if (props.editingTest.completing) {
                values.status = statuses.COMPLETED
            }
            props.dispatch(updateTest(props.editingTest.test.id, values, () => {props.close()}))
        } else {
            props.dispatch(createTest(values, () => {props.close()}))
        }
    }

    //console.log('createTest', props)
    return (<div className="create-form-container">
            <div className="create-form-header">
                <h3>{((props.editingTest || {}).test || {}).reference ? `UPDATING TEST ${((props.editingTest || {}).test || {}).reference}` : `SCHEDULE NEW TEST`}</h3>
                <h4>Please be informed that the Engine Testing has been scheduled as follows:</h4>
            </div>

            <CreateTestForm
                onSubmit={handleSubmit}
                user={props.user}
                group={props.group}
                testGroup={props.testGroup}
                dispatch={props.dispatch}
                close={props.close}
                editingTest={(props.editingTest || {}).test}
                completing={(props.editingTest || {}).completing}
                uploadUrl={props.uploadUrl}
                dataError={props.dataError}
                loading={props.loading}
                unplannedTestsStatus={props.unplannedTestsStatus}
                unplannedInitiallyRejected={unplannedInitiallyRejected()}
            />

        {/*{props.dataError.createTest && <div>
                {`Error on creating test: ${props.dataError.createTest}`}
            </div>}
            {props.dataError.updateTest && <div>
                {`Error on updating test: ${props.dataError.updateTest}`}
            </div>}*/}
        </div>)
}

export default CreateTest



// WEBPACK FOOTER //
// ./src/components/tests/CreateTest.jsx